import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { AkaTravelProductIntroFormValues } from "./akaTravelProductIntroInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<AkaTravelProductIntroFormValues> => {
    const { getText } = TextManager;
    return Yup.object({
      isInsuranceFor: Yup.mixed<BooleanFormType>().required(
        getText("akatravelform.validation.isinsurancefor"),
      ),
    }).defined();
  };
